<crm-multi-select
  #multiSelectComponent
  [options]="_users"
  optionLabel="profile.name"
  filterBy="profile.name"
  [isFilterSelectedItems]="true"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [(selectedItems)]="selectedUsers"
  (selectedItemsChange)="selectedUsersChange.emit($event)"
  [label]="isFloatLabel ? label : ''"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled"
  [itemSubDescriptionField]="itemSubDescriptionField"
  [showClear]="showClear"
  [display]="display"
  [placeholder]="placeholder"
  [sort]="sort"
  [moveDown]="moveDown">
</crm-multi-select>
